export const getBase64 = (file) => {
  return new Promise(function (resolve, reject) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      var Archivo = reader.result;
      if (Archivo !== "") {
        resolve(Archivo);
      } else {
        reject("Error al cargar archivo");
      }
    }
  })
}
